// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cursor-pointer {
  cursor: pointer !important;
}

:host {
  background: #faf3e6 !important;
}

mat-sidenav-content {
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

ion-header {
  box-shadow: none !important;
  flex-shrink: 1;
}
ion-header .toolbar {
  background: white;
  z-index: 999;
  box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.1019607843);
  background: white;
}
@media (max-width: 992px) {
  ion-header .toolbar .logo_icon {
    display: none;
  }
}
ion-header .toolbar ion-icon {
  width: 155px;
  height: 50px;
}
@media (min-width: 991px) {
  ion-header .toolbar ion-icon {
    width: 160px;
    height: 60px;
  }
}
ion-header .toolbar .burger_block {
  display: flex;
  align-items: center;
}
ion-header .toolbar .burger_block .basket_version {
  position: relative;
  display: flex;
  justify-content: center;
}
@media (max-width: 992px) {
  ion-header .toolbar .burger_block .basket_version {
    display: none;
  }
}
ion-header .toolbar .burger_block .basket_version ion-icon {
  width: 35px !important;
  height: 35px !important;
}
ion-header .toolbar .burger_block .basket_version div {
  top: 0px;
  right: 0px;
  background: var(--ion-color-primary);
  border-radius: 50%;
  width: 15px;
  height: 15px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}
ion-header .toolbar .burger_block .basket_version div p {
  font-size: 10px;
  color: white;
  font-family: AppFontBold, sans-serif;
}
@media (max-width: 992px) {
  ion-header .toolbar .logo_icon {
    display: none;
  }
}
ion-header .toolbar .back_icon {
  width: 20px !important;
  height: 20px !important;
}
ion-header .toolbar .back-block {
  display: flex;
  align-items: center;
}
ion-header .toolbar .back-block ion-icon {
  margin-right: 5px;
}
ion-header .toolbar .desktop-logo {
  width: 120px !important;
  height: 50px !important;
  margin-left: 30px;
}
@media (max-width: 992px) {
  ion-header .toolbar .desktop-logo {
    display: none;
  }
}
ion-header .toolbar .burger_block {
  display: flex;
  align-items: center;
}
ion-header .toolbar .burger_block .basket_version {
  position: relative;
  display: flex;
  justify-content: center;
  width: 35px;
  height: 35px;
}
@media (max-width: 992px) {
  ion-header .toolbar .burger_block .basket_version {
    display: none;
  }
}
ion-header .toolbar .burger_block .basket_version ion-icon {
  width: 35px !important;
  height: 35px !important;
}
ion-header .toolbar .burger_block .basket_version div {
  top: 0px;
  right: 0px;
  background: var(--ion-color-primary);
  border-radius: 50%;
  width: 15px;
  height: 15px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}
ion-header .toolbar .burger_block .basket_version div p {
  font-size: 10px;
  color: white;
  font-family: AppFontBold, sans-serif;
}
ion-header .toolbar .venue_info_block {
  display: flex;
  align-items: flex-start;
  max-width: 70%;
}
ion-header .toolbar .venue_info_block .map_icon {
  width: 20px;
  height: 25px;
  margin-right: 5px;
}
ion-header .toolbar .venue_info_block span {
  padding: 1px 6px;
  background: var(--ion-color-primary);
  color: white;
  font-size: 10px;
  text-transform: uppercase;
  border-radius: 50px;
  font-family: AppFontBold, sans-serif;
}
@media (min-width: 991px) {
  ion-header .toolbar .venue_info_block span {
    font-size: 12px;
    padding: 3px 10px;
  }
}
ion-header .toolbar .venue_info_block .venue_info ion-icon {
  width: 11px;
  height: 11px;
}
@media (min-width: 991px) {
  ion-header .toolbar .venue_info_block .venue_info ion-icon {
    width: 13px;
    height: 13px;
  }
}
ion-header .toolbar .venue_info_block .venue_info h5 {
  cursor: pointer;
  font-size: 12px;
}
@media (min-width: 991px) {
  ion-header .toolbar .venue_info_block .venue_info h5 {
    font-size: 16px;
  }
}
ion-header .toolbar .venue_info_block .venue_info p {
  font-size: 10px;
}

.articles-wrapper {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 15px 40px;
}
@media (max-width: 992px) {
  .articles-wrapper {
    padding: 20px 0;
    justify-content: center;
  }
}

.item-responsive {
  display: block;
  margin: 0 0.4% 10px;
}
@media (min-width: 991px) {
  .item-responsive {
    width: 32.4%;
  }
}
@media (max-width: 992px) {
  .item-responsive {
    width: 92%;
  }
}
@media (min-width: 991px) and (max-width: 1399px) {
  .item-responsive {
    width: 49.1%;
  }
}

.main-row {
  height: 100%;
  overflow: hidden;
}
.main-row ion-col.hidden {
  visibility: hidden;
  min-height: 0px;
  height: 0px;
  transition: ease-out 1s;
}

app-order-content {
  display: block;
  height: 100%;
  width: 100%;
}

.order-col {
  min-width: 380px;
}

.padding-end {
  padding-right: 11px;
}

ion-footer {
  background: #fff;
  text-transform: uppercase;
}

@media (min-width: 991px) {
  .footer-btn {
    display: none;
  }
}

.hidden {
  opacity: 0;
  display: none !important;
  transition: 1s linear !important;
}

.category-header {
  padding: 20px 20px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
}
@media (min-width: 991px) {
  .category-header {
    padding: 0px 20px 10px;
  }
}
.category-header h3 {
  color: black;
  font-size: 20px;
  font-family: AppFontBold, sans-serif;
  text-transform: capitalize;
}
@media (min-width: 991px) {
  .category-header h3 {
    font-size: 27px;
    padding: 0px 30px 0px;
  }
}

mat-sidenav {
  box-shadow: -26px 11px 79px -10px rgb(149, 149, 149);
}

.order_basket_block {
  height: 100%;
  width: 450px;
  background: #f6f0eb;
}
.order_basket_block .order_basket_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 20px 25px 0px;
  background: white;
}
.order_basket_block .order_basket_header ion-icon {
  cursor: pointer;
}
.order_basket_block .order_basket_header .close_basket_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding-left: 20px;
  font-family: AppFont;
  font-size: 14px;
  color: var(--ion-color-black);
}
.order_basket_block .order_basket_header .close_basket_img_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d9d9d9;
  padding: 0 16.5px;
  height: 55px;
  width: 55px !important;
}
.order_basket_block .order_basket_header .close_basket_img_col .close_basket_img {
  height: 14px;
  width: 14px;
}
.order_basket_block .order_list_row {
  height: calc(95% - 70px);
  display: flex;
}
.order_basket_block .checkout_row {
  width: 100%;
  height: 50%;
  padding: 20px 20px 0px 20px;
}

.filters_section {
  position: fixed;
  bottom: -80%;
  left: 0;
  right: 0;
  background: white;
  overflow: hidden;
  transition: bottom 0.6s ease-in-out;
  box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.1);
}
.filters_section.visible {
  bottom: 0%;
  overflow: visible;
}

.bg-white {
  background: white;
  position: relative;
  padding: 10px 0px;
}

.separator {
  height: 14px;
  width: 100%;
  background: url('separator_doted.svg') no-repeat center center/100% 100%;
}
@media (min-width: 991px) {
  .separator {
    background: url('separator_doted2.svg') no-repeat center center/100% 130%;
    height: 26px;
    width: 100%;
  }
}
@media (min-width: 991px) and (max-height: 750px) {
  .separator {
    height: 11px;
  }
}

ion-spinner {
  color: white;
}

.margin-block {
  margin: 10px 20px 0px;
}
@media (min-width: 991px) {
  .margin-block {
    margin: 0px 40px;
  }
}

.separator_white_wrapper {
  width: 100%;
  padding: 20px;
}
@media (min-width: 991px) {
  .separator_white_wrapper {
    padding: 20px 50px;
  }
}
.separator_white_wrapper .separator_white {
  height: 14px;
  width: 100%;
  background: url('separator_doted_white.svg') no-repeat center center/100% 100%;
}
@media (min-width: 991px) {
  .separator_white_wrapper .separator_white {
    background: url('separator_doted2_white.svg') no-repeat center center/100% 130%;
    height: 20px;
  }
}
@media (min-width: 991px) and (max-height: 750px) {
  .separator_white_wrapper .separator_white {
    height: 11px;
  }
}

.text_type {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 5px;
  margin-bottom: 5px;
}
.text_type ion-icon {
  margin-left: 5px;
}

.padding-block {
  padding: 5px 20px;
}

.data-card {
  color: white;
}

.search-results {
  height: 20rem;
  overflow: scroll;
}

@keyframes pulseColor {
  0% {
    color: var(--ion-color-primary);
  }
  30% {
    color: black;
  }
  60% {
    color: var(--ion-color-danger);
  }
  100% {
    color: var(--ion-color-primary);
  }
}
.text-block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.text-block ion-icon {
  width: 25px !important;
  height: 25px !important;
  margin-right: 10px;
}
.text-block h5 {
  text-transform: uppercase;
  text-align: center;
  color: var(--ion-color-primary);
  animation: pulseColor 2s infinite alternate;
}
.text-block ion-icon {
  color: var(--ion-color-primary);
  animation: pulseColor 2s infinite alternate;
}

.table-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e0e0e0;
  border: 1px solid #ddd;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  height: 32px;
  padding: 0 12px;
  margin-right: 10px;
  transition: background 0.2s ease;
}
.table-chip-text {
  font-family: AppFontBold, sans-serif;
  font-size: 11px;
  line-height: 1.2;
  letter-spacing: 0.02em;
  text-align: center;
  text-transform: uppercase;
  color: #333;
  margin-right: 6px;
}
.table-chip-number {
  font-family: Title, sans-serif;
  font-size: 14px;
  line-height: 1;
  text-transform: uppercase;
  color: #111;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/menu/menu.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAMA;EACC,0BAAA;AALD;;AAQA;EACC,8BAAA;AALD;;AASA;EACC,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAND;;AAUA;EACC,2BAAA;EACA,cAAA;AAPD;AAQC;EACC,iBAAA;EAEA,YAAA;EACA,wDAAA;EAiDA,iBAAA;AAvDF;ACjBE;EDyBA;IAEE,aAAA;EANF;AACF;AAQE;EACC,YAAA;EACA,YAAA;AANH;AChCE;EDoCA;IAIE,YAAA;IACA,YAAA;EAJF;AACF;AAME;EACC,aAAA;EACA,mBAAA;AAJH;AAKG;EAIC,kBAAA;EACA,aAAA;EACA,uBAAA;AANJ;ACzCE;EDyCC;IAEE,aAAA;EAEH;AACF;AAEI;EACC,sBAAA;EACA,uBAAA;AAAL;AAEI;EACC,QAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAL;AACK;EACC,eAAA;EACA,YAAA;EACA,oCAAA;AACN;ACnEE;EDyEA;IAEE,aAAA;EAJF;AACF;AAME;EACC,sBAAA;EACA,uBAAA;AAJH;AAME;EACC,aAAA;EACA,mBAAA;AAJH;AAKG;EACC,iBAAA;AAHJ;AAME;EACC,uBAAA;EACA,uBAAA;EACA,iBAAA;AAJH;ACxFE;EDyFA;IAKE,aAAA;EAFF;AACF;AAYE;EACC,aAAA;EACA,mBAAA;AAVH;AAWG;EAIC,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAZJ;ACxGE;ED4GC;IAEE,aAAA;EAFH;AACF;AAQI;EACC,sBAAA;EACA,uBAAA;AANL;AAQI;EACC,QAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AANL;AAOK;EACC,eAAA;EACA,YAAA;EACA,oCAAA;AALN;AAWE;EACC,aAAA;EACA,uBAAA;EACA,cAAA;AATH;AAUG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AARJ;AAUG;EACC,gBAAA;EACA,oCAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,oCAAA;AARJ;AC3JE;ED4JC;IASE,eAAA;IACA,iBAAA;EANH;AACF;AASI;EACC,WAAA;EACA,YAAA;AAPL;ACrKE;ED0KE;IAIE,WAAA;IACA,YAAA;EALJ;AACF;AAOI;EACC,eAAA;EACA,eAAA;AALL;AC/KE;EDkLE;IAIE,eAAA;EAHJ;AACF;AAKI;EACC,eAAA;AAHL;;AAwMA;EACC,aAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;AArMD;ACxLE;EDyXF;IAME,eAAA;IACA,uBAAA;EAnMA;AACF;;AAsMA;EACC,cAAA;EACA,mBAAA;AAnMD;ACzME;ED0YF;IAIE,YAAA;EAjMA;AACF;ACxME;EDoYF;IAOE,UAAA;EA/LA;AACF;ACrME;ED4XF;IAUE,YAAA;EA7LA;AACF;;AAgMA;EACC,YAAA;EACA,gBAAA;AA7LD;AA+LE;EACC,kBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;AA7LH;;AAkMA;EACC,cAAA;EACA,YAAA;EACA,WAAA;AA/LD;;AAkMA;EACC,gBAAA;AA/LD;;AAkMA;EACC,mBAAA;AA/LD;;AAiMA;EACC,gBAAA;EACA,yBAAA;AA9LD;;ACtPE;EDsbF;IAEE,aAAA;EA7LA;AACF;;AAiMA;EACC,UAAA;EACA,wBAAA;EACA,gCAAA;AA9LD;;AAiMA;EACC,kBAAA;EAIA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAjMD;AC3QE;EDmcF;IAGE,sBAAA;EAvLA;AACF;AA6LC;EACC,YAAA;EACA,eAAA;EACA,oCAAA;EACA,0BAAA;AA3LF;ACtRE;ED6cD;IAME,eAAA;IACA,qBAAA;EAzLD;AACF;;AA6LA;EAGC,oDAAA;AA1LD;;AA4LA;EACC,YAAA;EACA,YA9d0B;EA+d1B,mBAAA;AAzLD;AAiMC;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2BAAA;EACA,iBAAA;AA/LF;AAiME;EACC,eAAA;AA/LH;AAkME;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,eAAA;EAEA,6BAAA;AAlMH;AAqME;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AAnMH;AAoMG;EACC,YAAA;EACA,WAAA;AAlMJ;AAuMC;EACC,wBAAA;EACA,aAAA;AArMF;AAuMC;EACC,WAAA;EACA,WAAA;EACA,2BAAA;AArMF;;AAwMA;EACC,eAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,mCAAA;EACA,+CAAA;AArMD;AAuMC;EACC,UAAA;EACA,iBAAA;AArMF;;AAyMA;EACC,iBAAA;EACA,kBAAA;EACA,iBAAA;AAtMD;;AAyMA;EACC,YAAA;EACA,WAAA;EACA,wEAAA;AAtMD;AC7WE;EDgjBF;IAKE,yEAAA;IACA,YAAA;IACA,WAAA;EApMA;AACF;AAqME;EATF;IAUG,YAAA;EAlMD;AACF;;AAqMA;EACC,YAAA;AAlMD;;AAqMA;EACC,qBAAA;AAlMD;ACjYE;EDkkBF;IAGE,gBAAA;EAhMA;AACF;;AAoMA;EACC,WAAA;EACA,aAAA;AAjMD;AC3YE;ED0kBF;IAIE,kBAAA;EA/LA;AACF;AAgMC;EACC,YAAA;EACA,WAAA;EACA,8EAAA;AA9LF;ACrZE;EDglBD;IAKE,+EAAA;IACA,YAAA;EA5LD;AACF;AA6LG;EARF;IASG,YAAA;EA1LF;AACF;;AA+LA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AA5LD;AA6LC;EACC,gBAAA;AA3LF;;AA8LA;EACC,iBAAA;AA3LD;;AA6LA;EACC,YAAA;AA1LD;;AA4LA;EACC,aAAA;EACA,gBAAA;AAzLD;;AA8LA;EACC;IACC,+BAAA;EA3LA;EA6LD;IACC,YAAA;EA3LA;EA6LD;IACC,8BAAA;EA3LA;EA6LD;IACC,+BAAA;EA3LA;AACF;AA6LA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;AA3LD;AA4LC;EACC,sBAAA;EACA,uBAAA;EACA,kBAAA;AA1LF;AA4LC;EACC,yBAAA;EACA,kBAAA;EACA,+BAAA;EACA,2CAAA;AA1LF;AA4LC;EACC,+BAAA;EAEA,2CAAA;AA3LF;;AA+LA;EACC,oBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,wCAAA;EAEA,YAAA;EACA,eAAA;EACA,kBAAA;EAEA,gCAAA;AA/LD;AAiMC;EACC,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EAEA,iBAAA;AAhMF;AAmMC;EACC,8BAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,WAAA;AAjMF","sourcesContent":["@import '../../../theme/mixins';\n\n$container_padding_top: 30px;\n$order_basket_block_width: 450px;\n$order_basket_block_max_width: 45%;\n\n.cursor-pointer {\n\tcursor: pointer !important;\n}\n\n:host {\n\tbackground: #faf3e6!important;\n}\n\n\nmat-sidenav-content {\n\twidth: 100%;\n\toverflow: hidden;\n\tdisplay: flex;\n\tflex-direction: column;\n\n}\n\nion-header {\n\tbox-shadow: none !important;\n\tflex-shrink: 1;\n\t.toolbar {\n\t\tbackground: white;\n\n\t\tz-index: 999;\n\t\tbox-shadow: 0px 4px 50px 0px #0000001a;\n\n\t\t.logo_icon {\n\t\t\t@include mobile {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\tion-icon {\n\t\t\twidth: 155px;\n\t\t\theight: 50px;\n\t\t\t@include desktop {\n\t\t\t\twidth: 160px;\n\t\t\t\theight: 60px;\n\t\t\t}\n\t\t}\n\t\t.burger_block {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\t.basket_version {\n\t\t\t\t@include mobile {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\tion-icon {\n\t\t\t\t\twidth: 35px !important;\n\t\t\t\t\theight: 35px !important;\n\t\t\t\t}\n\t\t\t\tdiv {\n\t\t\t\t\ttop: 0px;\n\t\t\t\t\tright: 0px;\n\t\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\twidth: 15px;\n\t\t\t\t\theight: 15px;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tp {\n\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\tcolor: white;\n\t\t\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\tbackground: white;\n\t\t.logo_icon {\n\t\t\t@include mobile {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t.back_icon {\n\t\t\twidth: 20px !important;\n\t\t\theight: 20px !important;\n\t\t}\n\t\t.back-block {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tion-icon {\n\t\t\t\tmargin-right: 5px;\n\t\t\t}\n\t\t}\n\t\t.desktop-logo {\n\t\t\twidth: 120px !important;\n\t\t\theight: 50px !important;\n\t\t\tmargin-left: 30px;\n\t\t\t@include mobile {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t// ion-icon {\n\t\t//   width: 155px;\n\t\t//   height: 50px;\n\t\t//   @include desktop {\n\t\t//     width: 200px;\n\t\t//     height: 80px;\n\t\t//   }\n\t\t// }\n\t\t.burger_block {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\t.basket_version {\n\t\t\t\t@include mobile {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\twidth: 35px;\n\t\t\t\theight: 35px;\n\t\t\t\tion-icon {\n\t\t\t\t\twidth: 35px !important;\n\t\t\t\t\theight: 35px !important;\n\t\t\t\t}\n\t\t\t\tdiv {\n\t\t\t\t\ttop: 0px;\n\t\t\t\t\tright: 0px;\n\t\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\twidth: 15px;\n\t\t\t\t\theight: 15px;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tp {\n\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\tcolor: white;\n\t\t\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.venue_info_block {\n\t\t\tdisplay: flex;\n\t\t\talign-items: flex-start;\n\t\t\tmax-width: 70%;\n\t\t\t.map_icon {\n\t\t\t\twidth: 20px;\n\t\t\t\theight: 25px;\n\t\t\t\tmargin-right: 5px;\n\t\t\t}\n\t\t\tspan {\n\t\t\t\tpadding: 1px 6px;\n\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\tcolor: white;\n\t\t\t\tfont-size: 10px;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t@include desktop {\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tpadding: 3px 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.venue_info {\n\t\t\t\tion-icon {\n\t\t\t\t\twidth: 11px;\n\t\t\t\t\theight: 11px;\n\t\t\t\t\t@include desktop {\n\t\t\t\t\t\twidth: 13px;\n\t\t\t\t\t\theight: 13px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\th5 {\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t@include desktop {\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tp {\n\t\t\t\t\tfont-size: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t// .header_block_info {\n\t\t//   display: flex;\n\t\t//   align-items: center;\n\t\t//   justify-content: flex-end;\n\t\t//   .user {\n\t\t//     width: 25px;\n\t\t//     height: 25px;\n\t\t//     padding-left: 10px;\n\n\t\t//   }\n\n\t\t//   .lang_selection {\n\t\t//     display: flex;\n\t\t//     align-items: center;\n\t\t//     justify-content: center;\n\t\t//     &_item {\n\t\t//       background: white;\n\t\t//       border-radius: 28px;\n\t\t//       display: flex;\n\t\t//       align-items: center;\n\t\t//       padding: 7px 15px;\n\t\t//       ion-img {\n\t\t//         width: 20px;\n\t\t//       }\n\t\t//       p {\n\t\t//         font-size: 14px;\n\t\t//         color: var(--text-color);\n\t\t//         text-transform: uppercase;\n\t\t//         font-family: AppFontBold, sans-serif;\n\t\t//         padding-left: 5px;\n\t\t//       }\n\t\t//     }\n\t\t//   }\n\t\t// }\n\t}\n\n\t//.categories-block {\n\t//\t.category-list {\n\t//\t\tvisibility: visible;\n\t//\t\topacity: 1;\n\t//\n\t//\t\theight: fit-content;\n\t//\t\t&.hide-scroll {\n\t//\t\t\tvisibility: hidden;\n\t//\t\t\topacity: 0;\n\t//\t\t\theight: 0px;\n\t//\t\t}\n\t//\t\ttransition: 1s linear;\n\t//\t\topacity: 1;\n\t//\t\tdisplay: flex;\n\t//\t\toverflow: auto;\n\t//\t\tscroll-behavior: smooth;\n\t//\t\t-ms-overflow-style: none;\n\t//\t\tscrollbar-width: none; /* Firefox */\n\t//\t\t// margin-bottom: 10px;\n\t//\t\t@include desktop {\n\t//\t\t\tjustify-content: center;\n\t//\t\t}\n\t//\n\t//\t\t@include desktop {\n\t//\t\t\t// flex-grow: 1;\n\t//\t\t\t> ion-chip {\n\t//\t\t\t\toverflow: unset;\n\t//\t\t\t\tdisplay: flex;\n\t//\t\t\t\tflex-grow: 1 !important;\n\t//\t\t\t\tpadding: 12px 16px !important;\n\t//\t\t\t}\n\t//\t\t}\n\t//\n\t//\t\t&::-webkit-scrollbar {\n\t//\t\t\tdisplay: none;\n\t//\t\t}\n\t//\t\t.line-dotted-block {\n\t//\t\t\tmin-width: 20px;\n\t//\t\t\theight: 63px;\n\t//\t\t\tdisplay: flex;\n\t//\t\t\tjustify-content: center;\n\t//\t\t\talign-items: center;\n\t//\t\t\t@include desktop {\n\t//\t\t\t\theight: 112px;\n\t//\t\t\t\tmin-width: 50px;\n\t//\t\t\t\tion-img {\n\t//\t\t\t\t\twidth: 23px;\n\t//\t\t\t\t}\n\t//\t\t\t}\n\t//\t\t}\n\t//\t\t// .line-dotted-block:last-child {\n\t//\t\t//   display: none;\n\t//\t\t// }\n\t//\t\t.category-wrapper {\n\t//\t\t\tdisplay: flex;\n\t//\t\t\tjustify-content: flex-start;\n\t//\t\t\talign-items: center;\n\t//\t\t\tmin-width: fit-content;\n\t//\t\t\t@include desktop {\n\t//\t\t\t\tmin-width: fit-content;\n\t//\t\t\t}\n\t//\t\t\t.category-name {\n\t//\t\t\t\tpadding-top: 10px;\n\t//\t\t\t\tfont-size: 12px;\n\t//\t\t\t\tword-break: break-word;\n\t//\t\t\t\tdisplay: -webkit-box;\n\t//\t\t\t\t-webkit-line-clamp: 1;\n\t//\t\t\t\t-webkit-box-orient: vertical;\n\t//\t\t\t\toverflow: hidden;\n\t//\t\t\t\ttext-overflow: ellipsis;\n\t//\t\t\t\tmargin-top: 0px;\n\t//\t\t\t\tfont-weight: 100;\n\t//\t\t\t\tmargin-bottom: 0px;\n\t//\t\t\t\twidth: 60px;\n\t//\t\t\t\ttext-align: center;\n\t//\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t//\t\t\t\tcolor: #979797;\n\t//\t\t\t\t@include desktop {\n\t//\t\t\t\t\twidth: 100px;\n\t//\t\t\t\t\tfont-size: 22px;\n\t//\t\t\t\t\t&.selected {\n\t//\t\t\t\t\t\tcolor: var(--text-color);\n\t//\t\t\t\t\t\ttransition: ease-in-out 0.5s;\n\t//\t\t\t\t\t}\n\t//\t\t\t\t}\n\t//\t\t\t}\n\t//\t\t\t// &:first-child {\n\t//\t\t\t// \tmargin-left: 12px;\n\t//\t\t\t// }\n\t//\n\t//\t\t\t// &:last-child {\n\t//\t\t\t// \tmin-width: 100% !important;\n\t//\t\t\t// }\n\t//\t\t\t&.selected {\n\t//\t\t\t\ttransition: 200ms linear;\n\t//\t\t\t\tion-chip {\n\t//\t\t\t\t\topacity: 1;\n\t//\t\t\t\t\tbackground: var(--ion-color-primary);\n\t//\t\t\t\t\theight: 80px;\n\t//\t\t\t\t\twidth: 80px;\n\t//\t\t\t\t\t@include desktop {\n\t//\t\t\t\t\t\twidth: 70px;\n\t//\t\t\t\t\t\theight: 70px;\n\t//\t\t\t\t\t}\n\t//\t\t\t\t\t.border-dotted {\n\t//\t\t\t\t\t\twidth: 78px;\n\t//\t\t\t\t\t\theight: 78px;\n\t//\t\t\t\t\t\t@include desktop {\n\t//\t\t\t\t\t\t\twidth: 65px;\n\t//\t\t\t\t\t\t\theight: 65px;\n\t//\t\t\t\t\t\t}\n\t//\t\t\t\t\t}\n\t//\t\t\t\t}\n\t//\t\t\t}\n\t//\n\t//\t\t\tion-chip {\n\t//\t\t\t\topacity: 1;\n\t//\n\t//\t\t\t\tborder-radius: 50%;\n\t//\t\t\t\tpadding: 5px;\n\t//\t\t\t\tbackground: white;\n\t//\n\t//\t\t\t\t// transition: color 200ms linear, background 200ms linear;\n\t//\t\t\t\ttext-transform: capitalize;\n\t//\t\t\t\tflex: 0 0 auto;\n\t//\t\t\t\theight: 60px;\n\t//\t\t\t\twidth: 60px;\n\t//\t\t\t\tmargin: 0px;\n\t//\t\t\t\tpadding: 0px;\n\t//\t\t\t\tposition: relative;\n\t//\n\t//\t\t\t\t@include desktop {\n\t//\t\t\t\t\theight: 60px;\n\t//\t\t\t\t\twidth: 60px;\n\t//\t\t\t\t}\n\t//\t\t\t\t.category-image {\n\t//\t\t\t\t\twidth: 80%;\n\t//\t\t\t\t\tmargin: 0 auto;\n\t//\t\t\t\t}\n\t//\t\t\t\t.border-dotted {\n\t//\t\t\t\t\tposition: absolute;\n\t//\t\t\t\t\ttop: 50%;\n\t//\t\t\t\t\tleft: 50%;\n\t//\t\t\t\t\ttransform: translate(-50%, -50%);\n\t//\t\t\t\t\twidth: 58px;\n\t//\t\t\t\t\theight: 58px;\n\t//\t\t\t\t\t@include desktop {\n\t//\t\t\t\t\t\theight: 55px;\n\t//\t\t\t\t\t\twidth: 55px;\n\t//\t\t\t\t\t}\n\t//\t\t\t\t}\n\t//\t\t\t}\n\t//\t\t}\n\t//\t}\n\t//}\n}\n\n.articles-wrapper {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\tflex-wrap: wrap;\n\tpadding: 15px 40px;\n\t@include mobile {\n\t\tpadding: 20px 0;\n\t\tjustify-content: center;\n\t}\n}\n\n.item-responsive {\n\tdisplay: block;\n\tmargin: 0 0.4% 10px;\n\t@include desktop {\n\t\twidth: 32.4%\n\t}\n\t@include mobile {\n\t\twidth: 92%;\n\t}\n\t@include tablet {\n\t\twidth: 49.1%;\n\t}\n}\n\n.main-row {\n\theight: 100%;\n\toverflow: hidden;\n\tion-col {\n\t\t&.hidden {\n\t\t\tvisibility: hidden;\n\t\t\tmin-height: 0px;\n\t\t\theight: 0px;\n\t\t\ttransition: ease-out 1s;\n\t\t}\n\t}\n}\n\napp-order-content {\n\tdisplay: block;\n\theight: 100%;\n\twidth: 100%;\n}\n\n.order-col {\n\tmin-width: 380px;\n}\n\n.padding-end {\n\tpadding-right: 11px;\n}\nion-footer {\n\tbackground: #fff;\n\ttext-transform: uppercase;\n}\n.footer-btn {\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n\n\n.hidden {\n\topacity: 0;\n\tdisplay: none !important;\n\ttransition: 1s linear !important;\n}\n\n.category-header {\n\tpadding: 20px 20px;\n\t@include desktop {\n\t\tpadding: 0px 20px 10px;\n\t}\n\ttext-transform: uppercase;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbackground: white;\n\th3 {\n\t\tcolor: black;\n\t\tfont-size: 20px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\ttext-transform: capitalize;\n\t\t@include desktop {\n\t\t\tfont-size: 27px;\n\t\t\tpadding: 0px 30px 0px;\n\t\t}\n\t}\n}\n\nmat-sidenav {\n\t-webkit-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t-moz-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\tbox-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n}\n.order_basket_block {\n\theight: 100%;\n\twidth: $order_basket_block_width;\n\tbackground: #f6f0eb;\n\n\t//&.open {\n\t//\t-webkit-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t//\t-moz-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t//\tbox-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t//}\n\n\t.order_basket_header {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tpadding: 25px 20px 25px 0px;\n\t\tbackground: white;\n\t\t\n\t\tion-icon {\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\t.close_basket_col {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tbackground: transparent;\n\t\t\tpadding-left: 20px;\n\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 14px;\n\n\t\t\tcolor: var(--ion-color-black);\n\t\t}\n\n\t\t.close_basket_img_col {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tbackground: #d9d9d9;\n\t\t\tpadding: 0 16.5px;\n\t\t\theight: 55px;\n\t\t\twidth: 55px !important;\n\t\t\t.close_basket_img {\n\t\t\t\theight: 14px;\n\t\t\t\twidth: 14px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.order_list_row {\n\t\theight: calc(95% - 70px);\n\t\tdisplay: flex;\n\t}\n\t.checkout_row {\n\t\twidth: 100%;\n\t\theight: 50%;\n\t\tpadding: 20px 20px 0px 20px;\n\t}\n}\n.filters_section {\n\tposition: fixed;\n\tbottom: -80%;\n\tleft: 0;\n\tright: 0;\n\tbackground: white;\n\toverflow: hidden;\n\ttransition: bottom 0.6s ease-in-out;\n\tbox-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.1);\n\n\t&.visible {\n\t\tbottom: 0%;\n\t\toverflow: visible;\n\t}\n}\n\n.bg-white {\n\tbackground: white;\n\tposition: relative;\n\tpadding: 10px 0px;\n}\n\n.separator {\n\theight: 14px;\n\twidth: 100%;\n\tbackground: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 100%;\n\t@include desktop {\n\t\tbackground: url('../../../assets/losteria/separator_doted2.svg') no-repeat center center/ 100% 130%;\n\t\theight: 26px;\n\t\twidth: 100%;\n\n\t\t@media (max-height: 750px) {\n\t\t\theight: 11px;\n\t\t}\n\t}\n}\nion-spinner {\n\tcolor: white;\n}\n\n.margin-block {\n\tmargin: 10px 20px 0px;\n\t@include desktop {\n\t\tmargin: 0px 40px;\n\t}\n}\n\n\n.separator_white_wrapper {\n\twidth: 100%;\n\tpadding: 20px;\n\t@include desktop {\n\t\tpadding: 20px 50px;\n\t}\n\t.separator_white {\n\t\theight: 14px;\n\t\twidth: 100%;\n\t\tbackground: url('../../../assets/icon/separator_doted_white.svg') no-repeat center center/ 100% 100%;\n\t\t@include desktop {\n\t\t\tbackground: url('../../../assets/losteria/separator_doted2_white.svg') no-repeat center center/ 100% 130%;\n\t\t\theight: 20px;\n\n\t\t\t@media (max-height: 750px) {\n\t\t\t\theight: 11px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.text_type {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding-top: 5px;\n\tmargin-bottom: 5px;\n\tion-icon {\n\t\tmargin-left: 5px;\n\t}\n}\n.padding-block {\n\tpadding: 5px 20px;\n}\n.data-card {\n\tcolor: white;\n}\n.search-results {\n\theight: 20rem;\n\toverflow: scroll;\n}\n\n\n\n@keyframes pulseColor {\n\t0% {\n\t\tcolor: var(--ion-color-primary);\n\t}\n\t30% {\n\t\tcolor: black;\n\t}\n\t60% {\n\t\tcolor: var(--ion-color-danger);\n\t}\n\t100% {\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n.text-block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tion-icon {\n\t\twidth: 25px !important;\n\t\theight: 25px !important;\n\t\tmargin-right: 10px;\n\t}\n\th5 {\n\t\ttext-transform: uppercase;\n\t\ttext-align: center;\n\t\tcolor: var(--ion-color-primary);\n\t\tanimation: pulseColor 2s infinite alternate;\n\t}\n\tion-icon {\n\t\tcolor: var(--ion-color-primary);\n\n\t\tanimation: pulseColor 2s infinite alternate;\n\t}\n}\n\n.table-chip {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\tbackground: #e0e0e0;\n\tborder: 1px solid #ddd;\n\tborder-radius: 16px;\n\tbox-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n\n\theight: 32px;\n\tpadding: 0 12px;\n\tmargin-right: 10px;\n\n\ttransition: background 0.2s ease;\n\n\t&-text {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 11px;\n\t\tline-height: 1.2;\n\t\tletter-spacing: 0.02em;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tcolor: #333;\n\n\t\tmargin-right: 6px;\n\t}\n\n\t&-number {\n\t\tfont-family: Title, sans-serif;\n\t\tfont-size: 14px;\n\t\tline-height: 1;\n\t\ttext-transform: uppercase;\n\t\tcolor: #111;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n\n// Narrow desktop range — catches the cramped layout users see at 125–150% browser\n// zoom on common screen widths, before the mobile breakpoint takes over.\n@mixin tablet {\n  @media (min-width: 991px) and (max-width: 1399px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
